import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import AccordionSection from './AccordionSection';

import colors from '../../../styling/colors';
import withTrackingPropsProvider from '../../../hocs/withTrackingPropsProvider';
import { BasisFont } from '../../../styling/mixins/typography';

const TRACKING_PROPS = {
  block_name: 'category_nav',
  block_row: 'category_nav',
};

const Container = styled.div`
  ${BasisFont};
  background: white;
  color: ${colors('lapel')};
  height: 100%;
  line-height: 1.5;
  position: relative;
`;

const Header = styled.header`
  background: ${colors('white')};
  border-bottom: 1px solid ${colors('alto')};
  font-weight: 500;
  height: 3.5rem;
  padding: 1rem;
  position: sticky;
  text-align: center;
  top: 0;
`;

const TrackedAccordionContainer = withTrackingPropsProvider(Container);

const Accordion = ({ className, nodes }) => {
  const [activeKey, setActiveKey] = useState(null);

  return (
    <TrackedAccordionContainer className={className} tracking={TRACKING_PROPS}>
      <Header>Browse</Header>
      {nodes.map(node => {
        const isKeyActive = activeKey === node.title;
        return (
          <AccordionSection
            isActive={isKeyActive}
            node={node}
            onClick={() => setActiveKey(isKeyActive ? null : node.title)}
          />
        );
      })}
    </TrackedAccordionContainer>
  );
};

Accordion.propTypes = {
  className: PropTypes.string,
  nodes: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
    }),
  ).isRequired,
};

export default React.memo(Accordion);
